import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IApiResponse } from '../shared/interface/interface';

const apiUrl = environment.API_BASE_URL_V3;

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(private http: HttpClient) { }

    /**
     * Step 1: request a one-time nonce and message to sign.
     */
    public walletChallenge(walletAddress: string): Observable<IApiResponse> {
        return this.http.post<IApiResponse>(
            `${apiUrl}management/auth/wallet/challenge`,
           { wallet_address: walletAddress },
           { withCredentials: true }
        );
    }

    /**
     * Step 2: submit the wallet signature for verification.
     * On success the backend runs the sub-admin signup/signin and returns a JWT.
     */
    public walletVerify(params: { wallet_address: string; signature: string; nonce: string }): Observable<IApiResponse> {
        return this.http.post<IApiResponse>(
            `${apiUrl}management/auth/wallet/verify`,
            params,
            { withCredentials: true }
        );
    }

    /**
     * Re-fetch the CSRF token for an existing session cookie (e.g. after a
     * page refresh where localStorage lost the token but the cookie is valid).
     */
    public fetchCsrfToken(): Observable<IApiResponse> {
        return this.http.get<IApiResponse>(
            `${apiUrl}management/auth/csrf-token`,
            { withCredentials: true }
        );
    }

    /**
     * Invalidate the current sub-admin session on the server.
     */
    public logout(): Observable<IApiResponse> {
        return this.http.post<IApiResponse>(
            `${apiUrl}management/auth/logout`,
            {},
            { withCredentials: true }
        );
    }
}
